import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import UnderConstruction from "../container/Blank/UnderConstruction";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Venue = () => {
  return (
    <React.Fragment>
      <SEO title="Venue | ICSI 2022" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Venue"
        content="For Participants"
        contentTwo="Venue"
        linkage="/"

      />

      <EmptyTwo>
        {/* <div className="entry-content title-center"> */}
        {/* <h3>ICSI&apos;2023 will be hosted by Harbin Institute of Technology (Shenzhen), and the specific venue information will be announced later. </h3> */}
        {/* </div> */}

        <div className="entry-content">
          <h3>Venue</h3>
          <br></br>
          <br></br>
          <h4>Virtual Meeting</h4>
          <br></br>
          <div>
            Considering the current inconvenience of international travel, ICSI&apos;2023 also provides an
            online participation channel. Authors can join our conference through designated online
            conference software.
            The ICSI Organizing Committee has chosen Tencent Conference as the software for the
            online conference. For countries and regions outside of China, VooV Meeting can be used for
            participation. The room numbers for the meetings are listed below.
            <br></br>
            <br></br>
            <strong>

              Note: Presentations should be in English.
            </strong>
          </div>
          <div className="space-60"></div>

          <h4>How to participate online</h4>
          <br></br>
          <div className="crucial2">
            The ICSI Organizing Committee decided to use Tencent Conference as the software for online conference.
            Countries and regions other than China can use VooV Meeting to participate. Room numbers for meetings are listed below.
            <br></br>

          </div>

          <br></br>
          <table>
            <thead>
              <tr>
                <th > Room Name</th>
                <th > Room Code </th>
                <th > Agenda </th>
                <th > Time</th>
              </tr>
              <tr>
                <td>ICSI Information Desk</td>
                <td> 191-851-624   </td>
                <td>Information Desk
                </td>
                <td>
                  13:00-18:00, July 14th
                </td>

              </tr>
              <tr>
                <td>Opening Ceremony</td>
                <td>556-120-041   </td>
                <td>  Opening Ceremony </td>
                <td  > 08:30-12:00, July 15th</td>
              </tr>
              <tr>
                <td> Online Room 1</td>
                <td> 	881-943-032  </td>
                <td>  Parallel Session 4  </td>
                <td rowSpan={2} > 13:20 - 17:20, July 15th
                  <br></br>09:00 - 12:00, July 16th
                </td>
              </tr>
              <tr>
                <td>  Online Room 2</td>
                <td>  347-3932-3134  </td>
                <td>  Parallel Session 5 </td>
              </tr>
            </thead>
          </table>

          <h3>How to Submit video</h3>
          <br></br>
          <div >
            The ICSI&apos;2023 conference supports the submission of speech videos to participate in the conference. If your speech time conflicts with your schedule, you can submit a 15-minute video, which will be played by the conference team.
            <br></br>
            The recorded video needs to be uploaded to the network disk and submitted to the conference team in the form of a link. It is recommended to use Alibaba Cloud or Baidu Cloud. And It is recommended to use onedrive in countries and regions other than China. The video needs to be submitted to the conference team two days in advance.
            <br></br>
            <br></br>
            <strong>
              Please note: Authors submitting videos need to participate in the opening ceremony and award ceremony of the conference.
            </strong>
          </div>

        </div>
        {/* <UnderConstruction/> */}
        <div className="entry-content">
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <h3>About the venue hotel</h3>

          <br></br>
          <h5>Due to operational issues at the Shenzhen Golden Lily Hotel, the hotel is unable to provide us with a venue for the conference as well as accommodation from the 14th to the 18th. </h5>
          <br></br>


          Venus Royal Hotel Shenzhen Shajing Qilin(Shenzhen International Convention and Exhibition Center) [维纳斯皇家酒店(深圳国际会展中心店)] is located in the west of Shenzhen City, with convenient transportation, sea, land and air connections, close to exit b of Ma&apos;anshan station of Shenzhen Airport Metro Line 11, about 15 minutes&apos; walk; It&apos;s about 15 minutes&apos; drive from Fuyong Hong Kong Macao wharf and 4 kilometers from Shajing Exhibition Center. It&apos;s the core area of Shajing business district in Shenzhen, which is known as the &apos;hometown of delicious food&apos;. Around the shopping malls, there are Shajing Jingji Baina, Shajing Xinsha Tianhong and Jinsha fairy tale, all about 300 meters.
          The nearby scenic spots are Fenghuangshan Forest Park in Shenzhen, one of the eight major forest parks planned to be built in Shenzhen. It is about 7km away from the hotel and 3.8km away from the sea pastoral tourism area; New exhibition center in Asia, about 3.8 km away from the hotel.
          It was formerly known as Shenzhen Qilin Mountain View Hotel. It is close to mountains and rivers and has a beautiful environment. It covers an area of 16000 square meters with a total construction area of more than 100000 square meters. The hotel has all kinds of facilities, more than 400 kinds of warm guest rooms with complete facilities.
          It has a luxurious pillarless banquet hall that can accommodate 1200 people at the same time, a multi-functional LED screen, seven meeting rooms for various business meetings, and a garden style free parking lot. Wudaoxiang cafeteria, lingnanhui seafood restaurant, zhongjihui private restaurant bring all kinds of food and wine. Swimming pool and other fitness and leisure facilities can meet the requirements of intelligent business, personalized social, leisure and vacation, and have become the flagship landmark buildings in the region.
          <br></br>
          <br></br>
          For more information about the hotel, please visit the website: <a className="simple-link" href="http://www.venusroyalhotel.com/">http://www.venusroyalhotel.com/</a>

          {/* The Chinese restaurant serves exquisite Cantonese cuisine and seafood, as well as authentic Hunan, Sichuan cuisine, Shaanxi noodles, and Guilin-style food. It can accommodate 300 people dining at the same time, and there are five VIP rooms that can accommodate 20-100 people each. The first floor has a comfortable and relaxing lobby bar. The hotel has complete entertainment and leisure facilities, including an indoor temperature-controlled swimming pool, tennis court, beauty salon, as well as entertainment facilities such as billiards and ping pong rooms. The multi-functional hall on the seventh floor covers an area of about 500 square meters and is equipped with three karaoke rooms, suitable for hosting large banquets, festive feasts, parties, andvarious celebratory activities. It can also be used as a large conference venue for up to 300 people. */}
          <p>&nbsp;</p>

          {/* <table><tr>
          <td width='50%'>
          <img
              src="./images/venue/venue2.jpg"
              alt="venue1"
              width="75%"
            />


          </td>
          <td width='50%'>
          <img
              src="./images/venue/venue1.jpg"
              alt="venue1"
              width="90%"
            />
          </td>
          </tr>
          </table>

            <br></br>
            <br></br> */}

          <h4>Location</h4>
          {/* <h5>Due to operational issues at the Shenzhen Golden Lily Hotel, the hotel is unable to provide us with a venue for the conference as well as accommodation from the 14th to the 18th. Therefore, the organizing committee is currently planning for a new venue. Once updated information becomes available, our team will notify all authors promptly.</h5> */}
            <strong>
          Address: 118 Shajing Road, Shajing street, Shajing Town, near Xinsha Road, directly opposite Jingji Baina square

          Opened in 2010, Venus Royal Hotel Shenzhen Shajing Qilin(Shenzhen International Convention and Exhibition Center).
            </strong>
          <br></br>
          <br></br>
          Please refer to the{" "}
          <a href="https://goo.gl/maps/UAFqUVjEc4nqS8MB8">Google</a> or{" "}
          <a href="https://j.map.baidu.com/76/RHf">Baidu</a> map to find the
          exact location of the conference venue.
          <p>&nbsp;</p>
          <div className="row">
            <iframe
              src="https://map.baidu.com/poi/%E7%BB%B4%E7%BA%B3%E6%96%AF%E7%9A%87%E5%AE%B6%E4%BC%9A%E8%AE%AE%E9%85%92%E5%BA%97(%E6%B7%B1%E5%9C%B3%E5%9B%BD%E9%99%85%E4%BC%9A%E5%B1%95%E4%B8%AD%E5%BF%83%E5%BA%97)/@12669909.38,2584820.02,13.25z?uid=fa79ebe79bfba7981c580070&ugc_type=3&ugc_ver=1&device_ratio=2&compat=1&pcevaname=pc4.1&querytype=detailConInfo&da_src=shareurl"
              width={900}
              height={600}
              loading="lazy"
            ></iframe>
          </div>

          <br></br>

          <h3>About the university</h3>
          Harbin Institute of Technology (Shenzhen), also known as HIT Shenzhen, is a Chinese university located in the city of Shenzhen. It is a satellite campus of the renowned Harbin Institute of Technology in Harbin, China. HIT Shenzhen was established in 2002, and it has quickly become a leading university in the fields of engineering, science, and technology.
          <br></br>
          <br></br>

          HIT Shenzhen offers undergraduate and graduate programs in a wide range of fields, including electrical engineering, mechanical engineering, computer science, materials science, and civil engineering. The university has a strong focus on research, and it has established a number of research centers and institutes in areas such as robotics, artificial intelligence, and advanced materials.
          <br></br>
          <br></br>
          As a modern and innovative university, HIT Shenzhen is committed to promoting international cooperation and exchange. The university has established partnerships with over 100 universities and research institutions around the world. It also has a large international student population, with students from more than 50 countries and regions.
          <p>&nbsp;</p>
          <p>&nbsp;</p>
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Venue;
